import React, { useRef ,useState,useEffect} from 'react'
import { Spin } from 'antd'
import QueryForm from './components/QueryForm'
import TableList from './components/TableList'
import AddMoel from './components/AddMoel'
import UpLoadMoel from './components/UpLoadMoel'
import {getCityListByProvinceId} from '../../crowdsourceManage/api'

function TaxSource() {
    const [cityData, setCityData] = useState([]) // 城市
    const TableListRef = useRef()
    const AddMoelRef = useRef()
    const UpLoadMoelRef = useRef()
    const refresh = (val,record) => {
        switch (val) {
            case 'query':
                TableListRef.current.getlist()
                break
            case 'add':
                AddMoelRef.current.showModal('新增')
                break
            case 'upSeal':
                UpLoadMoelRef.current.showModal(record)
                break
            default:
        }
    }
    useEffect(() => {
        getCityListByProvinceId().then((res) => {
            if (res.data.success) {
                setCityData(res.data.data)
            }
        })
    }, [])
    return (
        <Spin spinning={false}>
            <QueryForm cityData={cityData} refresh={refresh}></QueryForm>
            <TableList refresh={refresh} ref={TableListRef}></TableList>
            <AddMoel cityData={cityData} refresh={refresh} ref={AddMoelRef}></AddMoel>
            <UpLoadMoel ref={UpLoadMoelRef} refresh={refresh}></UpLoadMoel>
        </Spin>
    )
}
export default TaxSource
